import { capacitorService } from '../../application/CapacitorService';
import { Intercom } from './intercom';
import { IntercomNative } from './intercomNative';
import { IntercomWeb } from './intercomWeb';

export const intercom: Intercom = capacitorService.isNative() ? new IntercomNative() : new IntercomWeb();
